










// Composition
import { defineComponent } from '@vue/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// Components
import SearchHeader from '@/components/feature/search/header/SearchHeader.vue'
import Tabs from '@/components/feature/search/nav/Tabs.vue'
import ResultsProducts from '@/components/feature/search/results/ResultsProducts.vue'
import ResultsResources from '@/components/feature/search/results/ResultsResources.vue'

export default defineComponent({
  components: {
    SearchHeader,
    Tabs,
    ResultsProducts,
    ResultsResources,
  },

  setup() {
    const { ui, isProductTab } = storeToRefs(useSearchStore())

    return {
      isProductTab,
      ui,
    }
  },
})
